/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalCsmsConfigDto } from './ExternalCsmsConfigDto';
import {
    ExternalCsmsConfigDtoFromJSON,
    ExternalCsmsConfigDtoFromJSONTyped,
    ExternalCsmsConfigDtoToJSON,
    ExternalCsmsConfigDtoToJSONTyped,
} from './ExternalCsmsConfigDto';

/**
 * 
 * @export
 * @interface FindOrganizationDto
 */
export interface FindOrganizationDto {
    /**
     * 
     * @type {string}
     * @memberof FindOrganizationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FindOrganizationDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof FindOrganizationDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof FindOrganizationDto
     */
    parentId: string;
    /**
     * 
     * @type {string}
     * @memberof FindOrganizationDto
     */
    organizationType: FindOrganizationDtoOrganizationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FindOrganizationDto
     */
    mainLanguage: FindOrganizationDtoMainLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof FindOrganizationDto
     */
    createdById?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FindOrganizationDto
     */
    updatedById?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FindOrganizationDto
     */
    createdAt: Date;
    /**
     * 
     * @type {ExternalCsmsConfigDto}
     * @memberof FindOrganizationDto
     */
    externalCsmsConfig?: ExternalCsmsConfigDto | null;
}


/**
 * @export
 */
export const FindOrganizationDtoOrganizationTypeEnum = {
    Operator: 'Operator',
    Manufacturer: 'Manufacturer',
    Landlord: 'Landlord',
    Oem: 'OEM'
} as const;
export type FindOrganizationDtoOrganizationTypeEnum = typeof FindOrganizationDtoOrganizationTypeEnum[keyof typeof FindOrganizationDtoOrganizationTypeEnum];

/**
 * @export
 */
export const FindOrganizationDtoMainLanguageEnum = {
    En: 'en',
    Fr: 'fr',
    De: 'de'
} as const;
export type FindOrganizationDtoMainLanguageEnum = typeof FindOrganizationDtoMainLanguageEnum[keyof typeof FindOrganizationDtoMainLanguageEnum];


/**
 * Check if a given object implements the FindOrganizationDto interface.
 */
export function instanceOfFindOrganizationDto(value: object): value is FindOrganizationDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    if (!('organizationType' in value) || value['organizationType'] === undefined) return false;
    if (!('mainLanguage' in value) || value['mainLanguage'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function FindOrganizationDtoFromJSON(json: any): FindOrganizationDto {
    return FindOrganizationDtoFromJSONTyped(json, false);
}

export function FindOrganizationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOrganizationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'active': json['active'],
        'parentId': json['parentId'],
        'organizationType': json['organizationType'],
        'mainLanguage': json['mainLanguage'],
        'createdById': json['createdById'] == null ? undefined : json['createdById'],
        'updatedById': json['updatedById'] == null ? undefined : json['updatedById'],
        'createdAt': (new Date(json['createdAt'])),
        'externalCsmsConfig': json['externalCsmsConfig'] == null ? undefined : ExternalCsmsConfigDtoFromJSON(json['externalCsmsConfig']),
    };
}

export function FindOrganizationDtoToJSON(json: any): FindOrganizationDto {
    return FindOrganizationDtoToJSONTyped(json, false);
}

export function FindOrganizationDtoToJSONTyped(value?: FindOrganizationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'active': value['active'],
        'parentId': value['parentId'],
        'organizationType': value['organizationType'],
        'mainLanguage': value['mainLanguage'],
        'createdById': value['createdById'],
        'updatedById': value['updatedById'],
        'createdAt': value['createdAt'].toISOString(),
        'externalCsmsConfig': ExternalCsmsConfigDtoToJSON(value['externalCsmsConfig']),
    };
}

